<div class="sml-control-group tw-relative">
  <input 
    type="text" 
    #googleAutocompletPlaceSearch 
    id="googleAutocompletPlaceSearch" 
    placeholder="Select or Enter" 
    class="sml-control" 
    [formControl]="addressControl"
    [(ngModel)]="address" 
    [ngClass]="{'sml-control-error': isInvalid}"
    />
</div>
